/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const bankDataTranslations = {
  iban: {
    label: "IBAN für Rückerstattung"
  }
};

export default bankDataTranslations;
